import { Chip } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FadeOutContainer } from '../components';
import { useSidebarMenu } from '../useSidebarMenu';
import { StyledButton, StyledFadeOutSpacer, StyledIconContainer } from './styled';
export function SidebarMenuSearch(props) {
    const { label, shortcutLabel, onClick } = props;
    const { minimized } = useSidebarMenu();
    return (<StyledButton $minimized={minimized} appearance="secondary" onClick={onClick}>
      <StyledIconContainer>
        <Falcon icon="search"/>
      </StyledIconContainer>
      <FadeOutContainer $minimized={minimized}>
        <StyledFadeOutSpacer>
          {label}
          <Chip appearance="secondary" label={shortcutLabel}/>
        </StyledFadeOutSpacer>
      </FadeOutContainer>
    </StyledButton>);
}
